import {Col, Container, Form, Row} from "react-bootstrap";
import React, {useState} from "react";
import {getSessionCustNo, VerifyConfigModel} from './VerifyConfigModel';
import {Link} from 'react-router-dom';
import {HttpMethod} from '../../model';
import {httpClient} from '../../service';

const CouponVerifyConfig = () => {
    const [validated, setValidated] = useState(false);
    const [model, setModel] = useState<VerifyConfigModel>({custNo: getSessionCustNo()});
    const [submitting, setSubmitting] = useState(false);

    const submitForm = async (e: any) => {
        const isValid = e.currentTarget.checkValidity();
        if (!isValid) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return false;
        }
        e.preventDefault();
        setSubmitting(true);

        const url = `test/verifications/coupon/config`;
        const options = {
            method: HttpMethod.POST,
            url,
            body:model
        }
        const act = await httpClient(options);
        setSubmitting(false);

        if (act.result) {
            sessionStorage.setItem("verifyConfig", JSON.stringify(model));
            alert('성공적으로 설정되었습니다.');
        } else {
            alert(act.errorMsg);
        }


    };
    const handleInputChange = (e: any) => {
        console.log(`name=${e.target.name}, value=${e.target.value}`);
        const data = {...model, [e.target.name]: e.target.value};
        setModel(data);
    }
    return (
        <Container className="bloc-sm">
            <Row className="mb-1">
                <Col className="col-sm-6 text-left">
                    <Link to="/verifications" className="btn btn-sm btn-primary">Home</Link>
                </Col>
                <Col className="col-sm-6 text-right">
                    <h6 className="mg-md subtitle">검증 시나리오 기본 환경 설정입니다..</h6>
                </Col>
            </Row>
            <Row>
                <Col className="s12">
                    <Form id="form_539" data-form-type="blocs-form" noValidate validated={validated}
                          onSubmit={submitForm}>
                        <Form.Group>

                            <Form.Label
                                className="form-label">검증 회원번호&nbsp;*</Form.Label>
                            <Form.Control name="custNo" required onChange={handleInputChange}
                                          defaultValue={model.custNo}
                            />
                            <Form.Control.Feedback type="invalid">
                                이 항목은 필수항목입니다.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <button type="submit"
                                className="bloc-button btn btn-d btn-lg btn-block download-bt"
                                disabled={submitting}
                        >{submitting ? "설정중.." : "저장하기"}
                        </button>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}
export default CouponVerifyConfig;
